import { saveRecentProductHistory } from "@/store/RecentStorage";

const SearchPlugin = (store) => {
  store.subscribe((mutation) => {
    if (mutation.type === "setRecentProductHistory") {
      const history = mutation.payload || [];

      saveRecentProductHistory(JSON.stringify(history));
    }
  });
};

export default SearchPlugin;
